import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";

export interface ParseTransportationPaymentRequest {
  file: File;
}

export interface ParseTransportationPaymentResponse {
  issuedOn: string | null; // ISO date (YYYY-MM-DD)
  amount: number | null;
  blNumber: string | null;
}

interface ParseTransportationPaymentPathParameter {
  agencyId: number;
}

export const parseTransportationPaymentKey: YWRKey<ParseTransportationPaymentPathParameter> =
  {
    url: ({ agencyId }) =>
      `/agencies/${agencyId}/transportation-payments/parse`,
    method: "post",
  };

export default function useParseTransportationPayment() {
  const fetcher = useFetcher<
    ParseTransportationPaymentRequest,
    ParseTransportationPaymentResponse
  >();
  return useYWR(parseTransportationPaymentKey, fetcher, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
